import { BILLING_TARIFF_ALIAS } from '@/features/billing/consts/tariff'

const { FREE, PREMIUM } = BILLING_TARIFF_ALIAS

export const isPremium = (alias: BILLING_TARIFF_ALIAS): boolean => {
  return alias === PREMIUM
}
